import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteCategory from "@/models/WebsiteCategory/WebsiteCategory";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";
import websiteWidgetCategoryShortcutWebsiteCategory
    from "@/models/WebsiteWidget/CategoryShortcut/WebsiteCategory/WebsiteWidgetCategoryShortcutWebsiteCategory";

export default class CategoryShortcut extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/category-shortcut';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetCategoryShortcuts';

    static model_name = 'CategoryShortcut';

    static fields() {
		return {
			id: this.number(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            websiteCategories: this.belongsToMany(WebsiteCategory, websiteWidgetCategoryShortcutWebsiteCategory, 'website_category_id','website_widget_category_shortcut_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteCategories() {
        return this.getRelated('websiteCategories');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
